<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-01 11:52:56
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-07-21 23:58:49
 * @Description: file content
 t9	在线售楼中心模板 对应的电子名片
 -->

<template>
  <div class="LayoutFound4">
    <remote-script
      charset="utf-8"
      src="https://assets.rurushishi.com/h5/lib/jquery/jquery-1.10.2.min.js"
    ></remote-script>
    <remote-link src="/sharelib/css/index.css?v=2"></remote-link>
    <remote-script charset="utf-8" src="/sharelib/sharelib.js"></remote-script>
    <router-view></router-view>
  </div>
</template>

<script>
import util from "@/utils/utils";
import Cookies from "js-cookie";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import request from "@/utils/request";
import global_ from "@/global.config";
export default {
  components: {},
  props: {},
  data() {
    return {
      selfAction: {
        //弹出自行动播放音乐
        promptSound: new Audio(
          "https://assets.rurushishi.com/sharelib/iPhone.mp3"
        ),
        triggerTime: 12, //等待时间秒
        passedTime: 0 //秒
      },
      //获取项目信息
      pcConfig: {
        callBtn: null, //致电 btns type 8
        navBtn: null, // 导航 btns type 9
        askBtn: null, // 咨询 btns type 10
        btns: [], //自定义按钮
        card: null //用户名片信息
      },
      uuid: "", //前端生成的唯一id
      cookieKeys: {
        cardid: "usercard4_cardid",
        uuid: "userCard4_uuid",
        masteropenid: "usercard4_masteropenid",
        projectid: "usercard4_projectid"
      },
      cookieDuration: new Date(new Date().getTime() + 60 * 1000 * 10)
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isLoading",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo",
      "sourceGzhInfo"
    ])
  },
  methods: {
    ...mapMutations({
      SET_RECEIVESPREADINFO: "SET_RECEIVESPREADINFO",
      SET_SHARESPREADINFO: "SET_SHARESPREADINFO",
      SET_PAGEINFO: "SET_PAGEINFO",
      SET_SOURCEGZHINFO: "SET_SOURCEGZHINFO"
    }),
    // 设置内容自行动
    setSelfAction: function() {
      let that = this;
      comreq.getPageSelfConfig(that.pageInfo.PageId).then(function(data) {
        // 设置了自行动，开启定时器
        if (data) {
          let zxdObj = Cookies.get("t9_20200131_self_" + that.pageInfo.PageId);
          if (zxdObj) {
            that.showSelfAction(1);
          } else {
            let tmpInterval = setInterval(function() {
              that.selfAction.passedTime++;
              if (that.selfAction.triggerTime == that.selfAction.passedTime) {
                that.showSelfAction(0);
                let inFifteenMinutes = new Date(
                  new Date().getTime() + 365 * 24 * 60 * 60 * 1000
                );
                Cookies.set("t9_20200131_self_" + that.pageInfo.PageId, 1, {
                  expires: inFifteenMinutes
                });
                clearInterval(tmpInterval);
              }
            }, 1000);
          }
        }
      });
    },
    showSelfAction: function(type) {
      let option = {
        pageid: this.pageInfo.PageId,
        openid: this.$openid,
        refereeopenid: this.$refereeopenid,
        passport: this.$passport,
        apiurl: this.global.API_URL
      };
      let chaturl = util.getGzhChatUrl(this);
      if (chaturl) {
        option.chaturl = chaturl;
      }
      if (type == 1) {
        option.type = 1;
      } else {
        // 自行动首次弹出
        this.selfAction.promptSound.play();
      }
      ShareLibSDK.showPageSelfConfig(option);
    },
    // 分享后页面
    showShareAfterAction: function() {
      let that = this;
      if (that.pageInfo.Showsharepage == 1) {
        let shareLibOption = {
          pageid: parseInt(that.pageInfo.PageId),
          openid: that.$openid,
          passport: that.$passport,
          apiurl: that.global.API_URL,
          refereeopenid: that.$refereeopenid
        };
        if (window.ShareLibSDK) {
          window.ShareLibSDK.showShareWin(shareLibOption);
        } else {
          let tmpInterval = setInterval(() => {
            if (window.ShareLibSDK) {
              window.ShareLibSDK.showShareWin(shareLibOption);
            }
          }, 500);
        }
      }
    },
    // 发送浏览时长
    sendTime(guid) {
      let that = this;
      let postObj = {
        openid: this.$openid,
        pageid: this.$pageid,
        tempid: guid,
        channelid: "",
        refereeopenid: this.$refereeopenid,
        projectid: that.$route.query.projectId || this.pageInfo.Pid,
        psn: this.$psn
      };
      comreq.actIp(this, postObj);
    },
    // 开始统计浏览时长
    setSendTime() {
      let that = this;
      let guid = util.getGuid();
      setTimeout(function() {
        that.sendTime(guid);
        setInterval(function() {
          that.sendTime(guid);
        }, 3000);
      }, 1000);
    },

    // ------统计-----
    // 获取项目信息
    setUuid: function() {
      var uuid = Cookies.get("userCard4_uuid");
      if (uuid) {
        this.uuid = uuid;
      } else {
        this.uuid = util.getGuid();
        Cookies.set(this.cookieKeys.uuid, this.uuid, {
          expires: this.cookieDuration
        });
      }
    },
    selectCardByProjectid() {
      let usercardopenid = this.$route.query.usercardopenid;
      if (this.global.isLoc && !usercardopenid) {
        usercardopenid = this.$openid;
      }
      let that = this;
      return new Promise(function(resolve, reject) {
        request
          .get(global_.API_URL, {
            action: "/electroniccard/ElectronicCardAction/getElectronicCard",
            requestParam: {
              projectid: parseInt(that.$route.query.projectId) || that.pageInfo.Pid,
              state: 1,
              masteropenid: usercardopenid
            }
          })
          .then(function(response) {
            console.log("response--", response);
            if (response.obj) {
              var data = response.obj;
              that.pcConfig.card = data;
              Cookies.set(that.cookieKeys.cardid, that.pcConfig.card.id, {
                expires: that.cookieDuration
              });
              that.saveCardLog();
              setInterval(() => {
                that.saveCardLog();
              }, 5000);
              if (data.btns) {
                data.btns.forEach(function(e) {
                  if (e.type == 9) {
                    that.pcConfig.callBtn = e;
                  } else if (e.type == 10) {
                    that.pcConfig.navBtn = e;
                  } else if (e.type == 11) {
                    that.pcConfig.askBtn = e;
                  } else {
                    that.pcConfig.btns.push(e);
                  }
                });
              }
            }
          });
      });
    },
    saveCardLog(imageid = "", btnid = "") {
      let that = this;
      let usercardopenid = that.$route.query.usercardopenid;
      if (that.global.isLoc && !usercardopenid) {
        usercardopenid = that.$openid;
      }
      return new Promise(function(resolve, reject) {
        request
          .get(global_.API_URL, {
            action: "/electroniccard/ElectronicCardAction/saveCardLog",
            requestParam: {
              obj: {
                cardid: that.pcConfig.card.id, //电子名片模板id
                uuid: that.uuid, //前端生成的唯一标识
                masteropenid: usercardopenid, //当前电子名片所属人的openid
                imageid: imageid, //如果是浏览的户型图详情，需要提交户型图的id
                btnid: btnid, //功能按钮的id
                referenceopenid: Cookies.get("openid"),
                // referenceopenid: that.$route.query.usercardopenid,
                projectid: that.pcConfig.card.projectid
              }
            }
          })
          .then(function(data) {});
      });
    },
    wxShare: function(imageid = "", btnid = "") {
      let that = this;
      let usercardopenid = that.$route.query.usercardopenid;
      if (that.global.isLoc && !usercardopenid) {
        usercardopenid = that.$openid;
      }
      return new Promise(function(resolve, reject) {
        request
          .get(global_.API_URL, {
            action: "/electroniccard/ElectronicCardAction/saveShare",
            requestParam: {
              obj: {
                cardid: that.pcConfig.card.id, //电子名片模板id
                uuid: that.uuid, //前端生成的唯一标识
                masteropenid: usercardopenid, //当前电子名片所属人的openid
                imageid: imageid, //如果是浏览的户型图详情，需要提交户型图的id
                btnid: btnid //功能按钮的id
              }
            }
          })
          .then(function(data) {
            console.log("测试分享", data);
          })
          .catch(function(error) {
            console.log(error);
          });
      });
    }
  },
  beforeCreate() {},
  created() {
    const that = this;
    that.usercardopenid = that.$route.query.usercardopenid;
    that.openid = this.$openid;
    that.setUuid();
    // let id = 0;
    // let psn = "";
    // if (that.$route.query.id && that.$route.query.psn) {
    //   let t9_20200131_initObj = {
    //     id: that.$route.query.id,
    //     psn: that.$route.query.psn
    //   };
    //   if (that.$route.query.refereeopenid) {
    //     t9_20200131_initObj.refereeopenid = that.$route.query.refereeopenid;
    //   }
    //   if (that.$route.query.rscuid) {
    //     t9_20200131_initObj.rscuid = that.$route.query.rscuid;
    //   }
    //   Cookies.set("t9_20200131_init", JSON.stringify(t9_20200131_initObj), {
    //     expires: new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000)
    //   });
    //   id = that.$route.query.id;
    //   psn = that.$route.query.psn;
    // } else {
    //   let initObj = Cookies.get("t9_20200131_init");
    //   if (initObj) {
    //     initObj = JSON.parse(initObj);
    //     if (initObj.id && initObj.psn) {
    //       id = initObj.id;
    //       psn = initObj.psn;
    //       let shareSpreadInfo = that.shareSpreadInfo;
    //       shareSpreadInfo.id = initObj.id;
    //       shareSpreadInfo.psn = initObj.psn;
    //       this.SET_SHARESPREADINFO(shareSpreadInfo);

    //       let receiveSpreadInfo = that.receiveSpreadInfo;
    //       receiveSpreadInfo.id = initObj.id;
    //       receiveSpreadInfo.psn = initObj.psn;
    //       if (initObj.refereeopenid) {
    //         receiveSpreadInfo.refereeopenid = initObj.refereeopenid;
    //       }
    //       if (initObj.rscuid) {
    //         receiveSpreadInfo.rscuid = initObj.rscuid;
    //       }
    //       this.SET_RECEIVESPREADINFO(receiveSpreadInfo);
    //     }
    //   }
    // }

    // let tmpTxt = "AI";
    // if (util.checkIsHuafa()) {
    //   tmpTxt = "";
    // }

    // if (id && psn) {
    // 获取页面信息
    // comreq.getPageInfo(id, psn, that).then(function(pageInfo) {
    //   that.SET_PAGEINFO(pageInfo);
    //   if (that.$route.query.isnew && that.$route.query.isnew == 1) {
    //     that.isShowCreateAfterGuide = true;
    //   }
    //   that.selectCardByProjectid();
    // });
    // 设置内容自行动
    util
      .checkMapStateCallback(that, ["shareSpreadInfo", "userInfo"])
      .then(() => {
        // 在线售楼中心，遇到销售或者职业经纪人带上rscuid传播。在楼盘详情如果有rscuid，销售员列表就只展示这个人。
        // if (util.checkIsHuafa()) {
        //   console.log("haufa==>", this.userInfo);
        //   //不走 内容自行动、获取渠道、agentInfo信息
        //   if (this.userInfo.salerOrAgent == true) {
        //     let shareSpreadInfo = that.shareSpreadInfo;
        //     shareSpreadInfo.rscuid = that.$openid;
        //     this.SET_SHARESPREADINFO(shareSpreadInfo);
        //   }
        //   that.global.SHARE_CALLBACK_OK = function() {
        //     comreq.actShare(that);
        //     // 先隐藏了分享后页面
        //     // that.showShareAfterAction();
        //     that.wxShare();
        //   };
        // } else {
        comreq.getUserIntegralInfo().then(userInfo => {
          if (
            userInfo.isSale == true ||
            (userInfo.isAgent == true &&
              userInfo.agentInfo &&
              userInfo.agentInfo.authtype == 2)
          ) {
            let shareSpreadInfo = that.shareSpreadInfo;
            shareSpreadInfo.rscuid = that.$openid;
            this.SET_SHARESPREADINFO(shareSpreadInfo);
          }
          // 微信网页
          // 需要设置分享
          that.global.SHARE_CALLBACK_OK = function() {
            comreq.actShare(that);
            // 先隐藏了分享后页面
            // that.showShareAfterAction();
            that.wxShare();
          };
          that.selectCardByProjectid();
        });
        // comreq
        //   .getChannelInfoByPageId(that.pageInfo.PageId)
        //   .then(function(sourceGzhInfo) {
        //     that.SET_SOURCEGZHINFO(sourceGzhInfo);
        //   });
        if (location.href.indexOf("noguide=1") > -1) {
          //
        } else {
          // 小原作为上级，没有fid这种不调用自行动，并去掉提示音
          if (that.$refereeopenid) {
            that.setSelfAction();
          }
        }
        // }

        that.setSendTime();
        // 上报设备信息
        comreq.actMt(that);
      });
    // } else {
    //   util.queryCheck(
    //     {
    //       id: "PageId",
    //       psn: "防刷参数"
    //     },
    //     that.$route.query
    //   );
    // }
  },
  mounted() {}
};
</script>
<style lang="css" scoped></style>
